import React from 'react';
import { IPublicClientApplication } from '@azure/msal-browser';
import LicenseActivation from './LicenseActivation';

interface Props {
  /** When provided, an admin can enter/activate a license key here. */
  pca?: IPublicClientApplication;
}

export default function LicenseExpired({ pca }: Props) {
  return (
    <div className="page" style={{ maxWidth: 560 }}>
      <div className="card" style={{ padding: 28 }}>
        <div className="eyebrow" style={{ marginBottom: 8 }}>DAGRUN PM</div>
        <h2 style={{ margin: '0 0 12px' }}>License Required</h2>
        <p style={{ color: 'var(--ink-3)', fontSize: 13, lineHeight: 1.6, margin: 0 }}>
          Your license is not active. If you have a license key, an administrator can activate it
          below. Otherwise, contact your tenant administrator.
        </p>
        {pca && <LicenseActivation pca={pca} />}
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            marginTop: 16,
            padding: '7px 14px',
            fontSize: 12,
            color: 'var(--ink-3)',
            background: 'transparent',
            border: '1px solid var(--border)',
            borderRadius: 'var(--r-md)',
            cursor: 'pointer',
          }}
        >
          Reload
        </button>
      </div>
    </div>
  );
}
